import React from "react";
import iconFail from "assets/img/icons/icon-warning.svg";
import { useNavigate } from "react-router-dom";

const ReturnIdentityFail = ({ close }) => {
  const navigate = useNavigate();
  return (
    <>
      <header className="modal-window__header">
        <img src={iconFail} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Something went wrong</h5>
        <p className="modal-window__info">Returning Identity was not completed.</p>
      </header>
      <footer className="modal-window__footer">
        <button
          className="modal-window__footer-close"
          onClick={() => {
            close();
            navigate("inventory/identities")
          }}
        >
          View Identities
        </button>
        <button className="modal-window__footer-close" onClick={close}>
          Done
        </button>
      </footer>
    </>
  );
};

export default ReturnIdentityFail;
